import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'

export const Spinner = <LoadingOutlined style={{ fontSize: 24 }} spin />
